export default __webpack_public_path__ + "static/media/quiqup.adf979ec.png";